<ng-container *transloco="let t; read: 'faq'">
  <section class="teaser">
    <div class="teaser-pics">
      <div
        class="teaser teaser1 active"
        [ngStyle]="{ backgroundImage: images[0] }"
      ></div>
    </div>
    <div class="content">
      <div class="title">{{ t("title") }}</div>
    </div>
  </section>
  <section class="headliner">
    <h2 [innerHTML]="t('requirements-question')"></h2>
    <div [innerHTML]="t('requirements-answer')"></div>
  </section>
  <hr />
  <section class="headliner">
    <h2 [innerHTML]="t('sources-question')"></h2>
    <div [innerHTML]="t('sources-answer')"></div>
  </section>
  <hr />
  <section class="headliner">
    <h2 [innerHTML]="t('store-question')"></h2>
    <div [innerHTML]="t('store-answer')"></div>
  </section>
  <hr />
  <section class="headliner">
    <h2 [innerHTML]="t('download-question')"></h2>
    <div [innerHTML]="t('download-answer')"></div>
    <a class="call" [routerLink]="['/download']">{{ t("download-button") }}</a>
  </section>
  <hr />
  <section class="headliner">
    <h2 [innerHTML]="t('rights-question')"></h2>
    <div [innerHTML]="t('rights-answer')"></div>
  </section>
  <hr />
  <section class="headliner">
    <h2 [innerHTML]="t('translation-question')"></h2>
    <div [innerHTML]="t('translation-answer')"></div>
  </section>
  <section class="headliner">
    <h2 [innerHTML]="t('usage-question')"></h2>
    <div [innerHTML]="t('usage-answer')"></div>
  </section>
</ng-container>
